import { register } from '../../../../Javascript/Sysmex/Utils'

const Newsroom = el => {
  const filterToggler = el.querySelector('.filter-toggler')
  const filterTogglerInput = filterToggler.querySelector('input:not([type="hidden"])')

  const toggleNews = function () {
    if (filterTogglerInput.checked) {
      el.classList.add('show-international-news')
    } else {
      el.classList.remove('show-international-news')
    }
  }

  filterToggler.addEventListener('click', function () {
    toggleNews()
  })

  toggleNews()
}

register('Newsroom', Newsroom)
